import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_STAFF_PAYMENTS].GET_REPORTS_STAFF_PAYMENTS]: {
		url: '/company/:companyId/reports/staff_payments/',
	},
	[ModulesConfigMap[ModulesMap.REPORTS_STAFF_PAYMENTS].GET_REPORTS_STAFF_PAYMENT]: {
		url: '/company/:companyId/reports/staff_payments/:staffPaymentId/',
	},
	[ModulesConfigMap[ModulesMap.REPORTS_STAFF_PAYMENTS].GET_REPORTS_STAFF_PAYMENT_PREVIEW]: {
		url: '/company/:companyId/reports/staff_payments/:staffPaymentId/preview/',
	},
}
